import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { ChevronDown } from "lucide-react";

export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[680px] w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center animate-slow-zoom"
          style={{
            backgroundImage:
              "url(/image/siteimages/gallery/photo-1595579547936-c3a0e6c171fc.jpg)"
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a2424]/85 via-[#0a2424]/55 to-[#0a2424]/95" />
        <div className="absolute inset-0 grain-overlay" />
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-5 lg:px-10 flex flex-col justify-center items-center text-center">
        <div className="animate-fade-up" style={{ animationDelay: "0.1s", opacity: 0 }}>
          <span className="divider-ornament text-spice-gold">Coastal Fusion Dining</span>
        </div>

        <h1
          className="font-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium tracking-tight mt-6 mb-4 leading-[1.05] max-w-5xl animate-fade-up"
          style={{ animationDelay: "0.25s", opacity: 0 }}
        >
          Sea Spice <span className="italic text-spice-gold font-light">Kitchen</span>
        </h1>

        <p
          className="text-white/85 text-lg md:text-xl tracking-wide font-light max-w-2xl animate-fade-up"
          style={{ animationDelay: "0.45s", opacity: 0 }}
        >
          Frankston's home of Coastal Fusion dining — fresh Australian seafood, authentic spices,
          and contemporary cuisine inspired by coasts around the world.
        </p>

        <div
          className="flex flex-wrap items-center justify-center gap-3 mt-4 mb-6 text-white/70 text-xs sm:text-sm tracking-[0.25em] uppercase animate-fade-up"
          style={{ animationDelay: "0.6s", opacity: 0 }}
        >
          <span>Fresh Seafood</span>
          <span className="text-spice-gold">•</span>
          <span>Global Flavours</span>
          <span className="text-spice-gold">•</span>
          <span>Memorable Experiences</span>
          
        </div>
       <div
  className="flex flex-wrap justify-center items-center gap-3 text-sm md:text-base uppercase tracking-[0.25em] font-semibold mb-8 animate-fade-up"
  style={{ animationDelay: "0.65s", opacity: 0 }}
>
  <span className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md">
    Open 7 Days
  </span>

  <span className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md">
    Breakfast
  </span>

  <span className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md">
    Lunch
  </span>

  <span className="px-4 py-2 bg-white rounded-full text-spice-gold shadow-md">
    Dinner
  </span>
</div>
       
        <div
          className="flex flex-col sm:flex-row items-center gap-4 animate-fade-up"
          style={{ animationDelay: "0.75s", opacity: 0 }}
        >
          <Link to="/reservations">
            <Button className="bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold tracking-wide rounded-none px-10 h-14 text-sm">
              Book Your Table Today
            </Button>
          </Link>
          <Link to="/menu">
            <Button
              variant="outline"
              className="bg-transparent border-white/40 text-white hover:bg-white hover:text-[#0d2929] hover:border-white tracking-wide rounded-none px-10 h-14 text-sm"
            >
              Explore Menu
            </Button>
          </Link>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 flex flex-col items-center gap-2 animate-fade-up" style={{ animationDelay: "1s", opacity: 0 }}>
        <span className="text-[10px] tracking-[0.4em] uppercase">Scroll</span>
        <ChevronDown size={18} className="animate-bounce" />
      </div>
    </section>
  );
}
